import React from 'react';
import Homepage from './components/pages/Homepage';
import About from './components/pages/About';
import Contact from './components/pages/Contact';
import Detail from "./components/pages/posts/Detail";
// import Aktuality from './components/pages/Aktuality';
import NotFound from './components/pages/NotFound';
import Section from './components/pages/posts/Section';
import TileFirst from './components/pages/TileFirst';
import TileSecond from './components/pages/TileSecond';
import TileThird from './components/pages/TileThird';
import TileFourth from './components/pages/TileFourth';
import TileFive from './components/pages/TileFive';
import TileSix from './components/pages/TileSix';
import Products from './components/pages/Products';
import Reference from './components/pages/Reference';
import Fotovoltaika from './components/pages/Fotovoltaika';
import SearchResults from './components/pages/SearchResults';
import InternalServerError from './components/pages/InternalServerError';
import { BrowserRouter, Switch, Route } from "react-router-dom";

export const routeCodes = {
  HOME: '/',  
  DETAILPOST: '/clanek/:slug',
  // AKTUALITY: '/aktuality',
  CONTACT: '/kontakty',
  ABOUT: '/o-spolecnosti',
  SECTION: '/odpovedna-firma',
  TILE1: '/dodavka-technologickych-konstrukci', 
  TILE2: '/dodavka-velkych-stavebnich-ocelovych-konstrukci',
  TILE3: '/vyroba-obecnych-ocelovych-svarencu',
  TILE4: '/zakazkove-obrabeni',
  TILE5: '/hydraulika',
  TILE6: '/projekty-na-klic',
  SEARCHRESULTS: '/hledat/:search',
  REFERENCE: '/reference', 
  PRODUKTS: '/produkty-a-sluzby',
  FOTOVOLTAIKA: '/fotovoltaika',
  };

class App extends React.Component {
	render() {
		return (
      <BrowserRouter basename="">
        <Switch>
          <Route path={ routeCodes.HOME } component={Homepage} exact />          
          <Route path={ routeCodes.DETAILPOST } component={Detail} exact />
          {/* <Route path={ routeCodes.AKTUALITY } component={Aktuality} exact /> */}
          <Route path={ routeCodes.CONTACT } component={Contact} exact />
          <Route path={ routeCodes.ABOUT } component={About} exact />
          <Route path={ routeCodes.SECTION } component={Section} exact />
          <Route path={ routeCodes.TILE1 } component={TileFirst} exact />
          <Route path={ routeCodes.TILE2 } component={TileSecond} exact />
          <Route path={ routeCodes.TILE3 } component={TileThird} exact />
          <Route path={ routeCodes.TILE4 } component={TileFourth} exact />
          <Route path={ routeCodes.TILE5 } component={TileFive} exact />
          <Route path={ routeCodes.TILE6 } component={TileSix} exact />
          <Route path={ routeCodes.PRODUKTS } component={Products} exact />
          <Route path={ routeCodes.REFERENCE } component={Reference} exact />
          <Route path={ routeCodes.FOTOVOLTAIKA } component={Fotovoltaika} exact />
          <Route path={ routeCodes.SEARCHRESULTS } component={SearchResults} exact />
          <Route path="/500" component={InternalServerError} />
          <Route path="*" component={NotFound} />
        </Switch>
      </BrowserRouter>
		);
	}
}

export default App;
